// extracted by mini-css-extract-plugin
module.exports = {"select":"select__XbE7v"};